<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'usersCrud'"
          crudName="Tipos Unidades de Saúdes"
          newText="Novo"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "tipoVeiculoTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: [
        "tipo_veiculo_id",
        "tipo_veiculo_codigo",
        "tipo_veiculo_nome",
        "status",
        "actions",
      ],
      tableData: [
        "tipo_veiculo_id",
        "tipo_veiculo_codigo",
        "tipo_veiculo_nome",
        "status",
      ],
      options: {
        saveState: true,
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "tipo_veiculo_id",
          "tipo_veiculo_codigo",
          "tipo_veiculo_nome",
          "status",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          tipo_veiculo_id: "ID",
          tipo_veiculo_codigo: "Código do Tipo do Veículo",
          tipo_veiculo_nome: "Nome do Tipo do Veículo",
          status: "Status",
          actions: "Ações",
        },
        sortable: [
          "tipo_veiculo_id",
          "tipo_veiculo_codigo",
          "tipo_veiculo_nome",
          "status",
        ],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: "Ativo",
            },
            {
              id: 0,
              text: "Inativo",
            },
          ],
        },
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["company"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "tipo_veiculo",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    query: function (query) {
      let columns = {
        tipo_veiculo_id: "tipo_veiculo_id",
        tipo_veiculo_codigo: "tipo_veiculo_codigo",
        tipo_veiculo_nome: "tipo_veiculo_nome",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>